import React, { useState } from 'react';

import { observer } from 'mobx-react-lite';

import { isMobile } from '@pascal/pascal-core';

import { totalBetStore } from '../../store/totalBetStore';

import WebScene from './webScene';
import MobileScene from './mobileScene';

const BetSection = observer(() => {
  const { totalBetForNote, setTotalBetForNote } = totalBetStore;

  const [isOpenBetPopup, setIsOpenBetPopup] = useState(false);
  const [isOpenCashOutPopup, setIsOpenCashOutPopup] = useState(false);

  return (
    <>
      {isMobile() ? (
        <MobileScene
          isOpenBetPopup={isOpenBetPopup}
          totalBetForNote={totalBetForNote}
          setIsOpenBetPopup={setIsOpenBetPopup}
          isOpenCashOutPopup={isOpenCashOutPopup}
          setTotalBetForNote={setTotalBetForNote}
          setIsOpenCashOutPopup={setIsOpenCashOutPopup}
        />
      ) : (
        <WebScene
          isOpenBetPopup={isOpenBetPopup}
          totalBetForNote={totalBetForNote}
          setIsOpenBetPopup={setIsOpenBetPopup}
          isOpenCashOutPopup={isOpenCashOutPopup}
          setTotalBetForNote={setTotalBetForNote}
          setIsOpenCashOutPopup={setIsOpenCashOutPopup}
        />
      )}
    </>
  );
});

export default BetSection;
